import React from 'react';

//compoenents
import { Cpds } from '@Cpds.Ui';
import { CpdsCardFigure } from '../styles/card-figure';
import { Video, VideoProps } from 'src/components/common/modules/video-player/video';

//types
import { CpdsCardFigureProps } from '../typings';
import { checkValue } from 'src/components/common/helper';

//todo
//hande the vide

const CardImageComponent: React.FC<CpdsCardFigureProps> = (props) => {
  const placeholderSrcDefault =
    'https://cdn.sanity.io/images/nxpteyfv/media-studio/4eac2877cf1372bc2ccd04c48bdf8344d6cdc1a9-330x312.png?fit=max&w=250&h=250';

  const {
    exClasses,
    altText,
    videoPoster,
    videoUrl,
    imgsrc,
    turnOnGradient,
    tinyImageLoader = true,
    srcSet,
    sizes,
    imageArray,
    placeholderSrc = placeholderSrcDefault,
    customVideoProps,
    ...rest
  } = props;

  const videoProps: VideoProps = {
    src: videoUrl,
    exClass: 'cpds-card-component-video',
    autoPlay: true,
    muted: true,
    loop: true,
    poster: videoPoster,
    playsInline: true,
    heroScrollDownArrow: true,
    hideSoundControlsForVideo: true,
    hideVideoPlayControls: 'True',
    altText: altText,
    ...customVideoProps,
  };

  return (
    <CpdsCardFigure key="cpds-media-conatiner" className={exClasses} {...rest}>
      {checkValue(videoUrl) ? (
        <Video {...videoProps} />
      ) : (
        <Cpds.Image
          alt={altText}
          exClasses="cpds-card-component-image"
          placeholderSrc={placeholderSrc || placeholderSrcDefault}
          usePlaceholder
          src={imgsrc}
          {...(srcSet ? { srcSet } : {})}
          {...(sizes ? { sizes } : {})}
          tinyImageLoader={tinyImageLoader}
          turnOnGradient={turnOnGradient}
          {...{ imageArray, srcSet }}
        />
      )}
    </CpdsCardFigure>
  );
};
CardImageComponent.displayName = 'CardMediaComponent';
export { CardImageComponent };
